module.exports = __webpack_public_path__ + "media/images/new_home/save-white-e461208609e81c3ef66185c4b90898cc.png";